class Settings {
	/**
	 * Retrieves the value of a specified setting.
	 * DATATOOLS_SETTINGS is added to the global scope by the WordPress plugin in core.php
	 *
	 * @param {string} name - The name of the setting
	 * @throws Will throw an error if the setting is not found
	 * @returns {*} The value of the setting
	 */
	static getSetting(name) {
		if (typeof DATATOOLS_SETTINGS !== 'undefined' && name in DATATOOLS_SETTINGS) {
			return DATATOOLS_SETTINGS[name];
		}

		throw new Error(`Setting ${name} not found.`);
	}

	/**
	 * Get Department Name for usage with the DataTools API.
	 *
	 * @returns {*}
	 */
	static getDepartmentName() {
		return this.getSetting('departmentName');
	}

	/**
	 * Are ABR lookups enabled?
	 *
	 * @returns {boolean}
	 */
	static areAbrLookupsEnabled() {
		return true === this.getSetting('isAbrLookupEnabled');
	}

	/**
	 * Are ABR lookups enabled?
	 *
	 * @returns {boolean}
	 */
	static areInactiveAbrRecordsIncluded() {
		return true === this.getSetting('includeInactiveAbrRecords');
	}

	/**
	 * Is Address Autocompletion enabled?
	 *
	 * @returns {boolean}
	 */
	static isAddressAutocompletionEnabled() {
		return true === this.getSetting('isAddressAutocompletionEnabled');
	}

	/**
	 * Is Email Validation enabled?
	 *
	 * @returns {boolean}
	 */
	static isEmailValidationEnabled() {
		return true === this.getSetting('isEmailValidationEnabled');
	}
}

export default Settings;
